import React, {useEffect, useState} from 'react';
import {TableCell} from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import useAppUtil from "../../../hooks/useAppUtil";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import {
  bulkDeleteEstablishmentMutation,
  deleteEstablishmentCache,
  getAllEstablishmentsQuery
} from "../../../gql/establishmentGql";

const Results = ({className, ...rest}) => {
  const { currentBrand } = useAuth();
  const { addWarning, addError} = useAppUtil();
  const [itemSource, setItemSource] = useState(null);

  useEffect(() => {
    async function setItemSourceAsync() {
      let result = await getEstablishments();
      setItemSource(result);
    }
    setItemSourceAsync();
  }, [currentBrand]);


  const getEstablishments = async () => {
    return await executeQueryUtil(getAllEstablishmentsQuery(currentBrand().id));
  }

  const getTableCellColumn = () => {
    return(
      <React.Fragment>
        <TableCell>
          {localStrings.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const getTableCell = (item) => {
    return(
      <React.Fragment>
        <TableCell>
          {item.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const deleteRestaurants = async (ids, size) => {
    await executeMutationUtil(bulkDeleteEstablishmentMutation(currentBrand().id, ids));
    await deleteEstablishmentCache(currentBrand().id, ids);
    let itemUpdate = await getEstablishments();
    setItemSource(itemUpdate)
    return true;
  }


  const sortOptions = [
    {
      value: 'name|asc',
      label: localStrings.name
    },
  ];

  return (
    <>
      { itemSource ?
        <GeneralResult
          className={className}
          getPathToData={(result) => result.data.getEstablishments}
          getTableCell={getTableCell}
          getTableCellColumn={getTableCellColumn}
          getEditLink={(item) => "/dashboard/establishments/detail/" + item.id}
          deleteDialogText={localStrings.confirmMessage.deleteItem}
          deleteItemsFunction={deleteRestaurants}
          deleteItemNotifMessage={localStrings.notif.establishmentDeleted}
          sortOptions={sortOptions}
          searchProperties={['name']}
          itemsSource={itemSource}
        >
        </GeneralResult>
        :
        <ClipLoaderComponent/>
      }
    </>
  )

};


export default Results;
